/**
 * Scripts that are tightly coupled to the index templates -- account, login, register etc
 *
 * Compiles to ./dist/assets/scripts/template.index.js
 */

import { activateSectionToggle } from '../sections/accounts';
import { customerAddresses } from '../utilities/customers/addresses';

activateSectionToggle();
customerAddresses();
